import { FaqCategoryItem } from "../../types";

import { DOWNLOAD_STUDENT_ANSWERS_FAQ } from "./DownloadStudentAnswersFaq";
import { PDF_DOWNLOAD_ERROR_FAQ } from "./PdfDownloadErrorFaq";

export const STUDENT_DATA_ITEMS: FaqCategoryItem[] = [
  DOWNLOAD_STUDENT_ANSWERS_FAQ,
  PDF_DOWNLOAD_ERROR_FAQ,
];
